let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

(function() {
  try {
    const MEASUREMENT_ID = 'G-0CV94E19P1';
    const GTM_RETRY_DELAY = 500;
    const GA_RETRY_DELAY = 200;
    const GA_TIMEOUT = 5000;
    const CHECKOUT_TIMEOUT = 3000;
    const ADD_TO_CART_DELAY = 200;
    const MAX_RETRIES = 5;

    // Simple ad blocker detection
    function detectAdBlocker() {
      try {
        const test = document.createElement('div');
        test.innerHTML = '&nbsp;';
        test.className = 'adsbox';
        test.style.position = 'absolute';
        test.style.left = '-999px';
        test.style.top = '-999px';
        document.body.appendChild(test);
        
        const blocked = test.offsetHeight === 0 || test.offsetWidth === 0;
        document.body.removeChild(test);
        
        return blocked;
      } catch (e) {
        return false;
      }
    }

    function sendToCart(data, isCheckout = false) {
      const payload = JSON.stringify({ attributes: data });
      if (isCheckout && navigator.sendBeacon) {
        const blob = new Blob([payload], { type: 'application/json' });
        if (!navigator.sendBeacon('/cart/update.js', blob)) {
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true })
            .catch(err => console.error('[GA Tracker] Both sendBeacon and fetch failed:', err));
        }
      } else {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: isCheckout })
          .catch(err => console.error('[GA Tracker] Failed to update cart:', err));
      }
    }

    function setFallbackId(reason, isCheckout = false) {
      const data = {
        ga_fallback_id: `${isCheckout ? 'checkout' : 'fallback'}-${Date.now()}`,
        ga_unavailable: reason,
        ga_ad_blocked: detectAdBlocker(),
        ga_timestamp: new Date().toISOString()
      };
      if (isCheckout) data.ga_checkout_triggered = true;
      sendToCart(data, isCheckout);
    }

    function getGaIdsWithTimeout(timeoutMs, onSuccess, onFallback) {
      const updates = {};
      let completed = 0;
      let done = false;
      
      const finish = (callback) => {
        if (done) return;
        done = true;
        clearTimeout(timeout);
        callback();
      };
      
      const checkComplete = () => {
        if (++completed === 3) {
          finish(() => Object.keys(updates).length > 0 ? onSuccess(updates) : onFallback('no-ga-ids-retrieved'));
        }
      };
      
      const timeout = setTimeout(() => finish(() => onFallback('timeout')), timeoutMs);
      
      try {
        gtag('get', MEASUREMENT_ID, 'client_id', cid => { if (cid) updates.ga_client_id = cid; checkComplete(); });
        gtag('get', MEASUREMENT_ID, 'session_id', sid => { if (sid) updates.ga_session_id = sid; checkComplete(); });
        gtag('get', MEASUREMENT_ID, 'session_number', snum => { if (snum) updates.ga_session_number = snum; checkComplete(); });
      } catch (error) {
        finish(() => onFallback('gtag-error'));
      }
    }

    function hasExistingGaIds(cart) {
      return cart && cart.attributes && 
        cart.attributes.ga_client_id && 
        cart.attributes.ga_session_id && 
        cart.attributes.ga_session_number;
    }

    function setFallbackIfNeeded(reason, isCheckout = false) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (hasExistingGaIds(cart)) {
            console.log('[GA Tracker] Cart already has GA IDs - skipping fallback');
            return;
          }
          setFallbackId(reason, isCheckout);
        })
        .catch(() => {
          setFallbackId(reason, isCheckout);
        });
    }

    function setGaIdsOnCart(retries = MAX_RETRIES) {
      if (typeof gtag === 'undefined') {
        if (retries > 0) {
          setTimeout(() => setGaIdsOnCart(retries - 1), GTM_RETRY_DELAY);
        } else {
          setFallbackIfNeeded('gtag-not-loaded');
        }
        return;
      }

      getGaIdsWithTimeout(GA_TIMEOUT, 
        (updates) => sendToCart(updates),
        (reason) => {
          if (reason === 'no-ga-ids-retrieved' && retries > 0) {
            setTimeout(() => setGaIdsOnCart(retries - 1), GA_RETRY_DELAY);
          } else {
            setFallbackIfNeeded(reason);
          }
        }
      );
    }

  function waitForGTM(attempts = 50) {
    if (typeof gtag !== 'undefined') {
      console.log('[GA Tracker] GTM ready, setting up listeners');
      setupListeners();
    } else if (attempts > 0) {
      console.log('[GA Tracker] Waiting for GTM to load...');
      setTimeout(() => waitForGTM(attempts - 1), 100);
    } else {
      console.warn('[GA Tracker] GTM failed to load, setting up basic listeners');
      setupListeners();
    }
  }

  function setupListeners() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, setGaIdsOnCart);
      console.log('[GA Tracker] Pub/sub listener set up');
    } else {
      console.warn('[GA Tracker] Pub/sub not available, skipping pub/sub listener');
    }

    document.addEventListener('skio::added-to-cart', setGaIdsOnCart);
    
    document.addEventListener('click', (event) => {
      const addToCartButton = event.target.closest('button[name="add"]');
      if (addToCartButton) {
        console.log('[GA Tracker] Add to cart button clicked - setting GA IDs');
        setGaIdsOnCart();
      }
    });
    
    console.log('[GA Tracker] Event listeners set up');
  }

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url] = args;
    const urlString = typeof url === 'string' ? url : url?.toString() || '';
    if (urlString && (urlString.includes('/cart/add.js') || urlString.includes('/cart/change.js') || urlString.includes('/cart/update.json'))) {
      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          console.log('[GA Tracker] Cart API call detected - setting GA IDs');
          setGaIdsOnCart();
        }
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };

  function checkCartOnLoad() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart && cart.items && cart.items.length > 0) {
          if (!hasExistingGaIds(cart)) {
            console.log('[GA Tracker] Cart missing GA IDs on page load - setting them');
            setGaIdsOnCart();
          }
        }
      })
      .catch(() => {
        // Ignore errors - cart might not exist yet
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCartOnLoad);
  } else {
    checkCartOnLoad();
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('button[name="checkout"]')) {
      let attempts = 0;
      const maxAttempts = 5;
      
      const tryGetGaIds = () => {
        attempts++;
        if (typeof gtag !== 'undefined') {
          getGaIdsWithTimeout(CHECKOUT_TIMEOUT, 
            (updates) => sendToCart(updates, true), 
            (reason) => setFallbackIfNeeded(reason, true)
          );
        } else if (attempts < maxAttempts) {
          setTimeout(tryGetGaIds, 500);
        } else {
          setFallbackIfNeeded('gtag-not-loaded', true);
        }
      };
      
      tryGetGaIds();
    }
  });

  waitForGTM();
  } catch (error) {
    console.error('[GA Tracker] Fatal error:', error);
    setFallbackIfNeeded('script-error');
  }
})();
